var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3304 0.459961H2.04712C0.927651 0.459961 0.0218958 1.37589 0.0218958 2.49537L0.0117188 20.814L4.08253 16.7432H18.3304C19.4498 16.7432 20.3658 15.8273 20.3658 14.7078V2.49537C20.3658 1.37589 19.4498 0.459961 18.3304 0.459961ZM16.295 12.6724H4.08253V10.637H16.295V12.6724ZM16.295 9.61928H4.08253V7.58388H16.295V9.61928ZM16.295 6.56617H4.08253V4.53077H16.295V6.56617Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.40f243e852416bf9f0a97aa00176db1c.svg";
export { ForwardRef as ReactComponent };